'use client';
import React, { useState } from 'react';
import {
  Select,
  MenuItem,
  Stack,
  useTheme,
  useMediaQuery,
  TextField,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

// Date Range Filter Component - Updated styling
const DateRangeFilter = ({ column, title }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDateRangeFilter = (start, end) => column.setFilterValue([start, end])

  const handleStartDateChange = (date) => {
    setStartDate(date);
    handleDateRangeFilter(date, endDate);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    handleDateRangeFilter(startDate, date);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack spacing={1}>
        <DatePicker
          label='From'
          value={startDate}
          onChange={handleStartDateChange}
          renderInput={(params) => (
            <TextField {...params} size="small" sx={{ minWidth: isMobile ? 100 : 140 }} />
          )}
        />
        <DatePicker
          label='To'
          value={endDate}
          onChange={handleEndDateChange}
          renderInput={(params) => (
            <TextField {...params} size="small" sx={{ minWidth: isMobile ? 100 : 140 }} />
          )}
        />
      </Stack>
    </LocalizationProvider>
  );
};

// Filter Component (updated to match TableFilter style)
export function Filter({ column }) {
  const columnFilterValue = column.getFilterValue();
  const { filterVariant, filterOptions } = column.columnDef.meta || {};

  // Date columns use date range filter
  if (column.id === 'eta' || column.id === 'statementDate') {
    return <DateRangeFilter column={column} title={column.columnDef.header} />;
  }

  // Status columns use select dropdown
  if (filterVariant === 'select') {
    return (
      <Select
        onChange={(e) => column.setFilterValue(e.target.value)}
        value={columnFilterValue ? columnFilterValue.toString() : ''}
        size="small"
        fullWidth
      >
        <MenuItem value="">All</MenuItem>
        <MenuItem value="Sent">Sent</MenuItem>
        <MenuItem value="Accepted">Accepted</MenuItem>
        <MenuItem value="Rejected">Rejected</MenuItem>
        <MenuItem value="Cancelled">Cancelled</MenuItem>
      </Select>
    );
  }

  if (filterVariant === 'selectStatus') {
    return (
      <Select
        value={columnFilterValue ?? 'all'}
        onChange={(e) => column.setFilterValue(e.target.value)}
      >
        {filterOptions.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    )
  }

  // Text columns use debounced input
  return (
    <TextField
      onChange={(e) => column.setFilterValue(e.target.value)}
      placeholder={`Search...`}
      type="text"
      value={columnFilterValue || ''}
      size="small"
      fullWidth
    />
  );
}